import { styled } from '@mui/material';

const Scrollbar = styled('div')(
    ({ theme }) => `
      overflow-y: auto;
      overflow-x: hidden;
      height: 100%;
      scrollbar-width: thin;
      scrollbar-color: ${theme.colors.alpha.black[30]} transparent;
  
      &::-webkit-scrollbar {
        width: 6px;
      }
  
      &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.alpha.black[30]};
        border-radius: 3px;
      }
  
      &::-webkit-scrollbar-track {
        background: transparent;
      }
  `
  );
  

export default Scrollbar;
